import { createContext, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/App.css";
import Home from "./pages/Home";
import JobList from "./pages/JobList";
import JobDetail from "./pages/JobDetail";
import JobDetailEdit from "./pages/JobDetailEdit";
import PostJob from "./pages/PostJob";
import NotFound from "./pages/NotFound";
import CreateNew from "./pages/CreateNew";
import PrivateRoute from "./routes/PrivateRoutes";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";

export const AppContext = createContext(null);

function App() {
  const [login, setLogin] = useState(null);
  return (
    <AppContext.Provider value={{ login, setLogin }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about" exact element={<AboutUs />} />
          <Route path="/contact" exact element={<ContactUs />} />
          <Route path="/job-list" exact element={<JobList />} />
          <Route path="/job-list/:category" exact element={<JobList />} />
          <Route
            path="/job-list/:category/:location"
            exact
            element={<JobList />}
          />
          <Route
            path="/job-list/:category/:location/:keyword"
            exact
            element={<JobList />}
          />
          <Route path="/job-detail/:jobid" exact element={<JobDetail />} />
          <Route
            path="/job-detail/:jobid/edit"
            exact
            element={
              <PrivateRoute>
                <JobDetailEdit />
              </PrivateRoute>
            }
          />

          <Route path="/post-job" exact element={<PostJob />} />
          <Route
            path="/create-new"
            exact
            element={
              <PrivateRoute>
                <CreateNew />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;
